import { reloadForStaleChunk as e } from "./reloadForStaleChunk.mjs";
import { useEffect as t, useState as n } from "react";
import { PageSkeleton as r } from "@maat/ds-core";
import { Fragment as i, jsx as a } from "react/jsx-runtime";
//#region src/staleChunk/StaleChunkReloadFallback.tsx
var o = ({ renderDefault: o }) => {
	let [s, c] = n(!1);
	return t(() => {
		e() || c(!0);
	}, []), s ? /* @__PURE__ */ a(i, { children: o() }) : /* @__PURE__ */ a(r, {});
};
//#endregion
export { o as StaleChunkReloadFallback };
